// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mt-1{margin-top:1px}.paging-container>.pagination{margin:0;display:flex}.paging-container>.pagination>li{display:block;list-style:none;margin:0 5px}.paging-container>.pagination>li>a{display:block;padding:2px 14px;border:1px solid #ececec;border-radius:3px;color:#000000}.paging-container>.pagination>li.active>a{color:#047fff;border:1px solid #047fff}.update-name-agent{position:absolute;top:20px;right:20px;z-index:3;padding:5px 20px}\n", ""]);
// Exports
module.exports = exports;
